/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import { Button, Form, Input, Modal, Select } from 'antd';
import UserService from '../../../services/UserService';
import { useEffect, useState } from 'react';
import DataFlowService from '../../../services/DataFlow.service';
import UserManagementService from '../../../services/UserManagement.service';
import { useNavigate, useParams } from 'react-router-dom';
import ModalFail from '../../../components/Shared/modal/fail';
import { ROUTER } from '../../../constants/router';

const { Option } = Select;

const ModalDataFlow = ({
    open,
    handelClose,
    mode,
    departmentList,
    dataFlowInfo,
    getInventoryDataFlowInfo,
}) => {
    let { businessProcessId } = useParams();
    let navigate = useNavigate();
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();
    // const currentUser = UserService.getName();
    const id = UserService.getUi();

    const [currentSelectBu, setCurrentSelectBu] = useState('');
    const [disable, setDisable] = useState(true);
    const [openFail, setOpenFail] = useState(false);
    const [msg, setMsg] = useState('');
    const [departments, setDepartments] = useState([]);

    const [currentUser, setCurrentUser] = useState('');
    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    const getUserDetail = async () => {
        try {
            const { data } = await UserManagementService.getUserDetail(id);
            const item = data?.resultData;
            setCurrentUser(`${item?.fname} ${item?.lname}`);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getUserDetail();
    }, []);

    useEffect(() => {
        getDataOwner();
    }, [currentSelectBu]);

    useEffect(() => {
        setDepartments(departmentList);
    }, [departmentList]);

    useEffect(() => {
        if (dataFlowInfo) {
            getDepartment();
            setCurrentSelectBu(dataFlowInfo.departmentId);

            const newDataOwners = [];
            dataFlowInfo.dataOwnerList.forEach((element) => {
                newDataOwners.push(element.userId);
            });

            form.setFieldsValue({
                departmentId: dataFlowInfo.departmentId,
                businessProcessFullName: dataFlowInfo.businessProcessFullName,
                purpose: dataFlowInfo.purposeName,
            });
        }

        if (!admin && departments.length > 0) {
            form.setFieldsValue({
                departmentId: departments[0].id,
            });
            setCurrentSelectBu(departments[0].id);
            setDisable(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const getDepartment = async () => {
        try {
            let lang = i18n.language;
            const { data } = await DataFlowService.getDepartmentList();
            if (data?.resultData) {
                let option = [];
                data?.resultData?.forEach((element) => {
                    option.push({
                        value: lang === 'en' ? element.nameEn : element.nameTh,
                        id: element.departmentId,
                    });
                });
                setDepartments(option);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const clear = () => {
        form.resetFields();
        setCurrentSelectBu('');
    };

    const getDataOwner = async () => {
        form.resetFields(['dataOwnerList']);

        if (currentSelectBu) {
            await DataFlowService.getDataOwner(currentSelectBu).then((res) => {
                let option = [];
                res?.data?.resultData?.forEach((element) => {
                    option.push({
                        value: element.name,
                        id: element.id,
                    });
                });
            });
        }
    };

    const onSubmit = async (e) => {
        if (mode === 'addDataFlow') {
            //create mode
            await DataFlowService.createDataFlow({ ...e })
                .then((res) => {
                    clear();
                    handelOk(res.data.resultData.businessProcessId);
                })
                .catch((err) => {
                    setOpenFail(true);
                    setMsg(err?.data?.errorData?.msg);
                });
        } else {
            //edit mode
            e.businessProcessId = businessProcessId;
            await DataFlowService.editDataFlow({ ...e })
                .then((res) => {
                    clear();
                    handelClose();
                    getInventoryDataFlowInfo();
                })
                .catch((err) => {
                    setOpenFail(true);
                    setMsg(err?.data?.errorData?.msg);
                });
        }
    };

    const handelOk = (id) => {
        handelClose();
        if (mode === 'addDataFlow') {
            navigate(`${ROUTER.DS_INVENTORY.DATAFLOW}/${id}`);
        }
    };

    return (
        <Modal
            className="_modal"
            footer={false}
            open={open}
            onCancel={() => {
                handelClose();
                clear();
            }}
        >
            <div>
                <div className="text-2xl font-semibold pb-12 text-center">
                    {mode === 'addDataFlow'
                        ? t('dataFlow.addDataFlow')
                        : t('dataFlow.editDataFlow')}
                </div>
                <Form form={form} layout="vertical" onFinish={onSubmit}>
                    <Form.Item
                        name="departmentId"
                        label={t('dataFlow.Department')}
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Select
                            disabled={mode === 'editDataFlow' || !admin}
                            size="large"
                            onChange={(e) => {
                                setCurrentSelectBu(e);
                                setDisable(false);
                            }}
                            placeholder={t('dataFlow.SelectDepartment')}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.children ?? '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                        >
                            {departments.map((e) => {
                                return (
                                    <Option key={e.id} value={e.id}>
                                        {e.value}
                                    </Option>
                                );
                            })}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={t('Data Flow Name')}
                        name="businessProcessFullName"
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Input.TextArea
                            rows={4}
                            disabled={mode !== 'addDataFlow' ? false : disable}
                            placeholder={t('Data Flow Name')}
                            maxLength={300}
                            showCount
                        />
                    </Form.Item>
                    <Form.Item
                        label={t('dataFlow.Purpose')}
                        name="purpose"
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Input.TextArea
                            rows={4}
                            disabled={mode !== 'addDataFlow' ? false : disable}
                            placeholder={t('dataFlow.PurposeDetails')}
                        />
                    </Form.Item>
                    <Form.Item label={t('dataFlow.updateBy')}>
                        <span className="opacity-80">{currentUser}</span>
                    </Form.Item>
                    <div className="flex justify-center items-center space-x-4 pt-12">
                        <Button
                            type="primary"
                            style={{ padding: '0px 30px' }}
                            onClick={() => {
                                handelClose();
                                clear();
                            }}
                            size="large"
                            ghost
                        >
                            {t('common.Cancel')}
                        </Button>

                        <Button
                            // disabled={mode === 'editDataFlow'}
                            htmlType="submit"
                            size="large"
                            type="primary"
                            style={{ padding: '0px 38px' }}
                        >
                            {mode === 'addDataFlow'
                                ? t('common.Next')
                                : t('common.Save')}
                        </Button>
                    </div>
                </Form>
            </div>
            <ModalFail
                text={msg}
                open={openFail}
                handelClose={() => {
                    setOpenFail(false);
                    clear();
                }}
            />
        </Modal>
    );
};
export default ModalDataFlow;
